import { apiRequest } from "./httpClient.js"

/** `GET /api/v1/servers/:serverId/console` (also used by ServerLogsPage via `.../logs`, same underlying Crafty log buffer). */
export function getServerConsole(serverId: string): Promise<{ lines: string[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/console`)
}

export function getServerLogs(serverId: string): Promise<{ lines: string[] }> {
  return apiRequest(`/api/v1/servers/${serverId}/logs`)
}

/** `POST /api/v1/servers/:serverId/console` — sends a command to the running server's stdin. */
export function sendServerCommand(serverId: string, command: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/console`, { method: "POST", body: { command } })
}
